import { pipeActions } from './actionHandler';
export function emitCustomEvent(instance, trigger, global, meta, payload, eventHandlers) {
    var key = instance.key, name = instance.name, emitEvents = instance.component.emitEvents;
    if (emitEvents && !emitEvents.find(function (i) { return i.eventName === trigger; })) {
        console.warn("Invalid event type [" + trigger + "] inside component [" + instance.component.name + "]");
        return;
    }
    // 触发renderer上的事件回调
    if (eventHandlers) {
        eventHandlers.forEach(function (eventHandler) {
            var eventName = eventHandler.eventName, proxyComponentKey = eventHandler.key, proxyComponentName = eventHandler.name, handler = eventHandler.handler;
            if (eventName === trigger && (proxyComponentKey === key || proxyComponentName === name)) {
                handler(key, name, payload);
            }
        });
    }
    var actions = instance.actions.filter(function (i) { return i.trigger === trigger; });
    if (!actions.length) {
        return;
    }
    var handler = pipeActions(actions, instance, undefined, payload);
    return handler(undefined, { global: global, meta: meta });
}
//# sourceMappingURL=customEventTrigger.js.map